import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { DescargaArchivosMensajes } from '../../../constants/mensajes-descarga-archivos';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss',
})
export class DashboardComponent {
  constructor(private toastService: ToastrService) {}

  downloadDiccionario() {
    this.toastService.info(
      DescargaArchivosMensajes.DESCARGA_INICIADA,
      DescargaArchivosMensajes.DESCARGA_INICIADA_TITULO,
      {
        timeOut: 2000,
      }
    );
    const link = document.createElement('a');
    link.href = `assets/files/Diccionario_de_variables.xlsx`;
    link.download = 'Diccionario_de_variables';
    link.click();

    setTimeout(() => {
      this.toastService.success(
        'Se ha finalizado la descarga del Diccionario de variables',
        DescargaArchivosMensajes.DESCARGA_SATISFACTORIA_TITULO,
        {
          timeOut: 2000,
        }
      );
    }, 1500);
  }

  downloadManual() {
    this.toastService.info(
      DescargaArchivosMensajes.DESCARGA_INICIADA,
      DescargaArchivosMensajes.DESCARGA_INICIADA_TITULO,
      {
        timeOut: 2000,
      }
    );
    const link = document.createElement('a');
    link.href = `assets/files/Manual_de_uso.pdf`;
    link.download = 'Manual_de_uso';
    link.click();
    setTimeout(() => {
      this.toastService.success(
        'Se ha finalizado la descarga del Manual de uso',
        DescargaArchivosMensajes.DESCARGA_SATISFACTORIA_TITULO,
        {
          timeOut: 2000,
        }
      );
    }, 1500);
  }
}
